import React, { useMemo, useState } from 'react';
import { Box, ButtonBase, Dialog, IconButton, Typography } from '@material-ui/core';
import _ from 'lodash';
import { CloseIcon } from '../../../../../components/Icon';
import { i18n } from '../../../../../language';
import BedStatusIcon from '../../BedStatusIcon';
import { baseCssOccupieddischarge } from '../baseCss';
import Updatetotbc from '../Updatetotbc';
import Updatetounavailable from '../Updatetounavailable';
import bsApp, { bedP as P } from '../../../bsApp';
import ServiceOrderBtn from '../../ServiceOrder/ServiceOrderBtn';
import { OrderedCleaningService } from '../../ServiceOrder';
import handleGetBsCleansingType from '../../../../../utils/handleGetBsCleansingType';
export default function AvaliableUnavaliableTbc({ closePop, allData, open, updateBedStatus }) {
  const baseClasses = baseCssOccupieddischarge();

  const [isUpdateUnavailablePop, setIsUpdateUnavailablePop] = useState(false);
  const updateUnavailableHandler = () => {
    setIsUpdateUnavailablePop(true);
  };
  const colseUpdateUnavailablePop = () => {
    setIsUpdateUnavailablePop(false);
  };

  const [isUpdateToTBCPop, setIsUpdateToTBCPop] = useState(false);
  const updateToTBCHandler = () => {
    setIsUpdateToTBCPop(true);
  };
  const closeUpdateToTBCPop = () => {
    setIsUpdateToTBCPop(false);
  };

  const updatetounavailable_confirmHandle = async (data) => {
    try {
      await updateBedStatus(
        {
          ...allData,
          ...data,
          targetStatus: bsApp.UNAVAILABLE,
          sourceStatus: bsApp.AVAILABLE,
        },
        closePop
      );
    } catch {}
  };

  const Updatetotbc_confirmHandle = async (data) => {
    // 绿色
    console.log('Updatetotbc_confirmHandle', data);
    try {
      await updateBedStatus(
        {
          ...allData,
          ...data,
          targetStatus: bsApp.TBC,
          sourceStatus: bsApp.AVAILABLE,
          ccWardCd: allData?.[P.ccWardCd],
        },
        closePop
      );
    } catch {}
  };

  const linkedBeds = useMemo(() => {
    if (allData.linkeds) {
      return [
        `${allData.ccWardCd} ${allData.bedNo}`,
        ..._.map(allData.linkeds, (item) => `${item.ccWardCd} ${item.bedNo}`),
      ];
    } else {
      return [];
    }
  }, [allData]);

  return (
    <>
      {isUpdateToTBCPop && (
        <Updatetotbc
          allData={allData}
          closePop={closeUpdateToTBCPop}
          open={isUpdateToTBCPop}
          confirmHandle={Updatetotbc_confirmHandle}
        />
      )}
      {isUpdateUnavailablePop && (
        <Updatetounavailable
          allData={allData}
          closePop={colseUpdateUnavailablePop}
          open={isUpdateUnavailablePop}
          confirmHandle={updatetounavailable_confirmHandle}
        />
      )}
      {!isUpdateToTBCPop && !isUpdateUnavailablePop ? (
        <Dialog open={open} maxWidth={false}>
          <div className={baseClasses.root} style={{ padding: '0 1.563rem' }}>
            <div className={baseClasses.header} style={{ padding: '2.063rem 0 1.688rem' }}>
              <Typography className={baseClasses.headerTitle}>{i18n.t('BEDSTATUS_BED_STATUS')}</Typography>
              <IconButton
                id="bed_avaliableunavaliabletbc_close_btn"
                className={baseClasses.closeIcon}
                onClick={closePop}
              >
                <CloseIcon />
              </IconButton>
            </div>
            <Box className={baseClasses.statusBox} justifyContent="space-between" pl="1.563rem">
              <Typography className={baseClasses.labelText}>{i18n.t('BEDSTATUS_BED_NO')}</Typography>
              <div className={baseClasses.status}>
                <BedStatusIcon allData={allData} disabled={true} />
              </div>
            </Box>
            {linkedBeds.length > 0 && (
              <Box display="flex" alignItems="center" mt="0.5rem">
                <Typography className={baseClasses.labelText}>
                  Linked Bed:
                  <span className={baseClasses.statusText} style={{ marginLeft: '0.5rem' }}>
                    {linkedBeds.join(', ')}
                  </span>
                </Typography>
              </Box>
            )}
            <OrderedCleaningService
              marginTop="1.87rem"
              marginLeft="0"
              tableName="B"
              tableId={allData?.bedStatusId}
              bedNo={allData?.bedNo}
              reminder={`bed ${allData?.bedNo}`}
            />
            <div className={baseClasses.bottom} style={{ marginBottom: '0.875rem', gap: '1.25rem' }}>
              <ButtonBase
                id="bed_avaliableunavaliabletbc_updatetounavalible"
                className={baseClasses.configBtn}
                style={{ background: '#ff7270' }}
                onClick={updateUnavailableHandler}
              >
                {i18n.t('BEDSTATUS_UPDATE_TO_UNAVAILABLE')}
              </ButtonBase>
              <ServiceOrderBtn
                hospCode={allData?.ccHosp}
                wardLocation={allData?.ccWardLocation}
                version={allData?.version}
                status={allData?.status}
                tableId={allData?.bedStatusId}
                tableName="B"
                closePop={closePop}
                reminder={`bed ${allData.linkedBedNo ?? allData?.bedNo}`}
                allData={allData}
                defaultLocation={`${allData.ccWardLocation} ${allData.ccWardCd ?? allData?.wardCd}`}
                defaultCleaningCase={handleGetBsCleansingType(allData)}
                defaultRemark={`${allData?.ccWardCd ?? allData?.wardCd} 床 ${allData?.bedNo}`}
              />
              <ButtonBase
                id="bed_avaliableunavaliabletbc_updatebedstatus"
                className={baseClasses.configBtn}
                onClick={updateToTBCHandler}
              >
                {i18n.t('BEDSTATUS_UPDATE_BED_STATUS')}
              </ButtonBase>
            </div>
          </div>
        </Dialog>
      ) : (
        ''
      )}
    </>
  );
}
